module.exports = __webpack_public_path__ + "static/img/history_order.08b9ebe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lifePay/history_order.png
// module id = O6Z6
// module chunks = 1